
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dao/[symbol]/proposal/[pk]",
      function () {
        return require("private-next-pages/dao/[symbol]/proposal/[pk]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dao/[symbol]/proposal/[pk]"])
      });
    }
  